// Profile related constants
export const EXCHANGES = ['MCX', 'NFO', 'CDS', 'DCSX'];

// Exchange & Market Status rows: `code` is matched against exchanges_subscribed,
// `sessionName` against session_name in the exchange session info API
export const EXCHANGE_SESSION_ROWS = [
  { code: 'NSE', label: 'NSE', sessionName: 'amo-nse-cm', type: 'daily', daysDisplay: 'Mon - Fri' },
  { code: 'NFO', label: 'NFO', sessionName: 'amo-nse-fo', type: 'daily', daysDisplay: 'Mon - Fri' },
  { code: 'BSE', label: 'BSE', sessionName: 'amo-bse-cm', type: 'daily', daysDisplay: 'Mon - Fri' },
  { code: 'BFO', label: 'BFO', sessionName: 'amo-bse-fo', type: 'daily', daysDisplay: 'Mon - Fri' },
  { code: 'MCX', label: 'MCX', sessionName: 'amo-mcx-fo', type: 'daily', daysDisplay: 'Mon - Fri' },
  { code: 'CDS', label: 'CDS', sessionName: 'amo-nse-cd', type: 'daily', daysDisplay: 'Mon - Fri' },
  { code: 'DCSX', label: 'DCSX', sessionName: 'amo-crypto-cm', type: 'daily_all_days', daysDisplay: 'All Days' },
  // US stocks trade under CDS, so their subscription follows CDS
  { code: 'CDS', label: 'US STOCK', sessionName: 'amo-us-stock', type: 'daily', daysDisplay: 'Mon - Fri' },
];

export const TAB_LABELS = {
  ACCOUNT_DETAILS: 'Account Details',
  PREFERENCES: 'Preferences',
};

export const TAB_INDICES = {
  ACCOUNT_DETAILS: 0,
  PREFERENCES: 1,
};

export const SNACKBAR_DURATION = 3000;

export const SCROLL_THRESHOLD = 300;

export const WELCOME_MESSAGE_DURATION = 5000;

export const REFERRAL_URL_FALLBACK = 'https://tradex.live/ref/R00049';

export const ANIMATION_DURATION = {
  FAST: 200,
  NORMAL: 300,
  SLOW: 500,
};

export const BREAKPOINTS = {
  MOBILE: 'sm',
  TABLET: 'md',
  DESKTOP: 'lg',
};

